import Duck from 'extensible-duck'

export const TOP_NAVIGATIONS_TYPE = {
  CATEGORY_NAVIGATION: 'CATEGORY_NAVIGATION',
  BEST_SELLERS_NAVIGATION: 'BEST_SELLERS_NAVIGATION',
  FOR_YOU_NAVIGATION: 'FOR_YOU_NAVIGATION',
}

const initialState = {
  banners: [],
  topNavigations: [],
  bottomNavigations: [],
  selectedTopNavigation: null,
  isHomepageCategoryPage: false,
}

const types = [
  'UPDATE_BANNERS',
  'UPDATE_TOP_NAVIGATIONS',
  'UPDATE_BOTTOM_NAVIGATIONS',
  'SET_IS_HOMEPAGE_CATEGORY_PAGE',
  'UPDATE_SELECTED_TOP_NAVIGATION',
  'RESET',
]

export default new Duck({
  namespace: 'content',
  store: 'homePage',
  types,
  initialState,
  reducer: (state, action, duck) => {
    switch (action.type) {
      case duck.types.UPDATE_BANNERS:
        return { ...state, banners: action.payload }
      case duck.types.UPDATE_TOP_NAVIGATIONS:
        return { ...state, topNavigations: action.payload }
      case duck.types.UPDATE_BOTTOM_NAVIGATIONS:
        return { ...state, bottomNavigations: action.payload }
      case duck.types.UPDATE_SELECTED_TOP_NAVIGATION:
        return { ...state, selectedTopNavigation: action.selectedTopNavigation }
      case duck.types.SET_IS_HOMEPAGE_CATEGORY_PAGE:
        return { ...state, isHomepageCategoryPage: action.payload }
      case duck.types.RESET:
        return initialState
      default:
        return state
    }
  },
  creators: (duck) => ({
    reset: () => ({ type: duck.types.RESET }),
    updateBanners: (payload) => ({
      type: duck.types.UPDATE_BANNERS,
      payload,
    }),
    updateTopNavigations: (payload) => ({
      type: duck.types.UPDATE_TOP_NAVIGATIONS,
      payload,
    }),
    updateBottomNavigations: (payload) => ({
      type: duck.types.UPDATE_BOTTOM_NAVIGATIONS,
      payload,
    }),
    updateSelectedTopNavigation: (selectedTopNavigation) => ({
      type: duck.types.UPDATE_SELECTED_TOP_NAVIGATION,
      selectedTopNavigation,
    }),
    setIsHomepageCategoryPage: (payload) => ({
      type: duck.types.SET_IS_HOMEPAGE_CATEGORY_PAGE,
      payload,
    }),
  }),
})
